<template>
    <div class="login">
        <div class="slogan">
            <img src="../../assets/img/logoapp.png" alt="" />
        </div>
        <div class="content">
            <van-form @submit="onSubmit">
                <div class="warp">
                    <van-field
                        v-model="username"
                        name="用户名"
                        label="用户名"
                        placeholder="请输入用户名"
                        :rules="[{ required: true, message: '请填写用户名' }]"
                    />
                </div>
                <div class="warp">
                    <van-field
                        v-model="password"
                        type="password"
                        name="密码"
                        label="密码"
                        placeholder="请输入密码"
                        :rules="[{ required: true, message: '请填写密码' }]"
                    />
                </div>
                <div style="margin: 50px 0">
                    <van-button class="loginBtn" color="#fff" round block type="info" native-type="submit"
                        >登录</van-button
                    >
                </div>
            </van-form>
        </div>
        <div class="footer">Copyright © 2023. L.L Golf Academy</div>
    </div>
</template>

<script>
import { Field, Form, Button, Toast } from 'vant'
import { mapMutations } from 'vuex'

export default {
    name: 'login-page',
    props: {},
    components: {
        [Button.name]: Button,
        [Form.name]: Form,
        [Field.name]: Field,
        [Toast.name]: Toast
    },
    data() {
        return {
            username: '',
            password: ''
        }
    },
    methods: {
        ...mapMutations(['CHANGE_COUNT']),
        onSubmit() {
            // if (this.password === '123456') {
            //     this.$router.push({ path: '/resetPassword' })
            //     return
            // }
            this.onLogin()
        },
        coach() {
            this.$router.push({ path: '/coach' })
        },
        onLogin() {
            let data = {
                username: this.username,
                password: this.password
            }
            this.$api.login.login(data).then((res) => {
                console.log(res)
                if (res.msg) {
                    return
                }
                localStorage.setItem('token', res.data.token)
                this.$api.login.getInfo().then((result) => {
                    if (result.msg) {
                        Toast.fail(result.msg)
                        return
                    }
                    localStorage.setItem('login', JSON.stringify(data))
                    localStorage.setItem('userInfo', JSON.stringify(result.data))
                    if (this.password === '123456') {
                        this.$router.push({ path: '/resetPassword' })
                        return
                    }
                    if (result.data.roles[0] === 'coach') {
                        localStorage.removeItem('currentDay')
                        this.$router.push({ path: '/coach' })
                    } else {
                        localStorage.removeItem('currentDay')

                        this.$router.push({ path: '/student' })
                        this.$api.student.getNoReadMessage(result.data.user.id).then((res) => {
                            this.CHANGE_COUNT(res.data.length)
                        })
                    }
                })
            })
        }
    },
    computed: {},
    watch: {},
    beforeCreate() {},
    created() {
        this.username = JSON.parse(localStorage.getItem('login')).username
        this.password = JSON.parse(localStorage.getItem('login')).password
    },
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    activated() {},
    deactivated() {},
    beforeDestroy() {},
    destroyed() {}
}
</script>

<style scoped lang="less">
.login {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-top: 150px;
    background-image: url('../../assets/img/bg.jpg');
    background-size: 100% 100%;
    background-position: bottom;

    .content {
        width: 75%;
        margin: 100px auto 0;

        .loginBtn {
            color: rgba(14, 190, 126, 1) !important;
            border-radius: 12px;
            width: 100%;
            padding: 12px;
        }

        .warp {
            width: 100%;
            background: #fff;
            border-radius: 12px;
            margin-bottom: 38px;
            overflow: hidden;
            min-height: 48px;

            .van-cell {
                min-height: 48px;

                ::v-deep .van-cell__title {
                    font-size: 14px;
                    color: rgba(27, 170, 118, 1);
                }
            }
        }
    }

    .slogan {
        font-family: 'PingFangSC-Semibold', '苹方-简 Semibold', '苹方-简', sans-serif;
        font-size: 32px;
        font-weight: 650;
        font-style: normal;
        // color: #1eb285;
        color: #fff;
        width: 100%;
        text-align: center;
    }

    .footer {
        width: 300px;
        font-size: 12px;
        text-align: center;
        color: #fff;
        position: fixed;
        bottom: 20px;
        left: 50%;
        margin-left: -150px;
    }
}
</style>
